import GiftRequestsItem from './GiftRequestsItem';
export default GiftRequestsItem;
